module.exports = __webpack_public_path__ + "src/img/newfabu.d5619178.svg";